module.exports = __webpack_public_path__ + "static/media/3tahun.6ce58403.png";